var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#FFEACC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8 8H20.2C17 8 15 10 15 13.2V17.25H21.25C21.66 17.25 22 17.59 22 18C22 18.41 21.66 18.75 21.25 18.75H15V22.8C15 26 17 28 20.2 28H22.79C25.99 28 27.99 26 27.99 22.8V13.2C28 10 26 8 22.8 8Z",
    fill: "#FF671E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5599 17.2498L12.6299 15.1798C12.7799 15.0298 12.8499 14.8398 12.8499 14.6498C12.8499 14.4598 12.7799 14.2598 12.6299 14.1198C12.3399 13.8298 11.8599 13.8298 11.5699 14.1198L8.21994 17.4698C7.92994 17.7598 7.92994 18.2398 8.21994 18.5298L11.5699 21.8798C11.8599 22.1698 12.3399 22.1698 12.6299 21.8798C12.9199 21.5898 12.9199 21.1098 12.6299 20.8198L10.5599 18.7498H14.9999V17.2498H10.5599Z",
    fill: "#FF671E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.f73431ba5a98e15fbd100f22798d43eb.svg";
export { ForwardRef as ReactComponent };